
import React, {Component} from 'react';
import {
  Button,
  Layout,
  Input,
  Radio,
  Switch,
  Pagination,
  Loading,
  Dialog,
  Table,
  Checkbox,
  Card,
  Tabs
} from "element-react";
import 'element-theme-default';
import * as V from 'victory';
import TopMenu from "../components/NavMenu";
import {
  customerUpdate,
  customerOpen,
  setAdminList,
  setCustomerFilter,
  setCustomerList,
  loginRecovery
} from "../actions";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import Facade from "../Facade";
import TimeUtil from "../TimeUtil";
import HseAuditResultChart from "../components/hse/HseAuditResultChart";
import ManpowerChart from "../components/manpower/ManpowerChart";
import ProjectSumTable from "../components/ProjectSumTable/index";
import DesignCommentsChart from "../components/designcomments/DesignCommentsChart";
import ContractSnagChart from "../components/ContractSnag/ContractSnagChart";
import PageWrapper from "./PageWrapper";
import ChartRfi from "../components/ChartRfi";
import ChartAqrl from "../components/ChartAqrl";
import ChartNcr from "../components/ChartNcr";
import ChartRisk from "../components/ChartRisk";
import WeekGraphCard from "../components/WeekGraphCard";
import "./DashboardPage.css";
import runRefreshTasks from "../controllers/runRefreshTasks";


const {Row,Col} =Layout;


class DashboardPage extends Component
{

  constructor(props)
  {
    super(props);
    this.state={
      isLoading: true,
      type :0
    };
  }




  componentDidMount()
  {

    // 图
    this.showScheduleChart("0");

  }
  componentWillUnmount()
  {
    if ( this.scheduleChart !=null) {window.disposeScheduleCanvas();this.scheduleChart=null}
  }

  //切换近期计划/基线计划  0近期  1~3基线 其中1阶段 2里程碑 3全部
  showScheduleChart (type){
    type = parseInt(type);
    if ( type == 0)
    {
      if ( this.scheduleChart !=null) {window.disposeScheduleCanvas();this.scheduleChart=null}
      var datasrc = {"title":"","defaultZoomBeginDate":"2022-03-08","defaultZoomEndDate":"2029-05-08",
        "dataset":[{"id":"3.0","name":"采购","start":"2021-07-21","end":"2022-05-15","baseline_start":"2021-07-21","baseline_end":"2022-05-15"},{"id":"3.1","name":"精装设计招标","start":"2021-07-21","end":"2021-08-06","baseline_start":"2021-07-21","baseline_end":"2021-08-06"},{"id":"3.2","name":"RFP-合同签署","start":"2022-01-28","end":"2022-05-15","baseline_start":"2022-01-16","baseline_end":"2022-05-15"},{"id":"3.3","name":"中标通知书发出","start":"2022-04-15","end":"2022-04-29","baseline_start":"2022-04-15","baseline_end":"2022-04-15"},{"id":"3.4","name":"精装合同签署","start":"2022-04-29","end":"2022-05-15","baseline_start":"2022-04-15","baseline_end":"2022-05-15"}]};
      this.scheduleChart = window.initScheduleCanvas(datasrc,"chart_schedule_container",1920,800);
    }else {
      //基线计划 3种
      this.switchScheduleType(type);
    }
    this.setState({type:type});
  }


  switchScheduleType(type)
  {
    window.disposeScheduleCanvas();
    var filterDatasrc = this.getFilterDatasrc(type);
    window.initScheduleCanvas(filterDatasrc, "chart_schedule_container", 1920, window.calcSuggestH(filterDatasrc));
    // setTimeout( function(){;},1000);

  }
   getFilterDatasrc( type ){
    var datasrc = {"dataset":[{"id":"1.0","name":"土地获取","type":"","start":"2021-06-22","end":"2021-07-07","baseline_start":"2021-06-22","baseline_end":"2021-07-07"},{"id":"1.1","name":"项目交割","type":"里程碑","start":"2021-06-28","end":"2021-06-30","baseline_start":"2021-06-28","baseline_end":"2021-06-30"},{"id":"2.0","name":"设计","type":"","start":"2021-07-08","end":"2022-01-28","baseline_start":"2021-07-08","baseline_end":"2021-12-30"},{"id":"2.1","name":"五项设计调整","type":"里程碑","start":"2021-07-08","end":"2021-12-17","baseline_start":"2021-07-08","baseline_end":"2021-10-30"},{"id":"2.2","name":"扩初据设计调整+确认","type":"一级","start":"2021-07-08","end":"2021-09-05","baseline_start":"2021-07-08","baseline_end":"2021-09-05"},{"id":"2.3","name":"施工图设计调整+确认","type":"一级","start":"2021-09-05","end":"2021-12-17","baseline_start":"2021-09-05","baseline_end":"2021-10-30"},{"id":"2.4","name":"规划沟通+审图","type":"一级","start":"2021-11-01","end":"2021-11-30","baseline_start":"2021-11-01","baseline_end":"2021-11-30"},{"id":"2.5","name":"精装修设计","type":"里程碑","start":"2021-08-07","end":"2022-01-28","baseline_start":"2021-08-07","baseline_end":"2021-12-30"},{"id":"2.6","name":"精装概念设计","type":"一级","start":"2021-08-07","end":"2021-10-30","baseline_start":"2021-08-07","baseline_end":"2021-10-30"},{"id":"2.7","name":"精装方案设计","type":"二级","start":"2021-09-16","end":"2021-11-17","baseline_start":"2021-09-16","baseline_end":"2021-11-16"},{"id":"2.8","name":"精装扩初招标图纸","type":"一级","start":"2021-12-02","end":"2022-01-28","baseline_start":"2021-12-02","baseline_end":"2021-12-30"},{"id":"3.0","name":"采购","type":"","start":"2021-07-21","end":"2022-05-15","baseline_start":"2021-07-21","baseline_end":"2022-05-15"},{"id":"3.1","name":"精装设计招标","type":"一级","start":"2021-07-21","end":"2021-08-06","baseline_start":"2021-07-21","baseline_end":"2021-08-06"},{"id":"3.2","name":"RFP-合同签署","type":"里程碑","start":"2022-01-28","end":"2022-05-15","baseline_start":"2022-01-16","baseline_end":"2022-05-15"},{"id":"3.3","name":"中标通知书发出","type":"二级","start":"2022-04-15","end":"2022-04-29","baseline_start":"2022-04-15","baseline_end":"2022-04-15"},{"id":"3.4","name":"精装合同签署","type":"二级","start":"2022-04-29","end":"2022-05-15","baseline_start":"2022-04-15","baseline_end":"2022-05-15"},{"id":"4.0","name":"报建报批","type":"","start":"2022-04-15","end":"2022-05-04","baseline_start":"2022-04-15","baseline_end":"2022-05-04"},{"id":"4.1","name":"精装修第三方图审备案","type":"一级","start":"2022-04-15","end":"2022-05-04","baseline_start":"2022-04-15","baseline_end":"2022-05-04"},{"id":"5.0","name":"施工","type":"","start":"2019-12-17","end":"2022-12-30","baseline_start":"2019-12-17","baseline_end":"2023-03-27"},{"id":"5.1","name":"土护降","type":"一级","start":"2019-12-17","end":"2021-09-04","baseline_start":"2019-12-17","baseline_end":"2021-09-04"},{"id":"5.2","name":"地下室施工至正负零","type":"一级","start":"2020-10-20","end":"2021-10-27","baseline_start":"2020-10-20","baseline_end":"2021-10-27"},{"id":"5.3","name":"主体楼板施工至封顶","type":"里程碑","start":"2021-02-16","end":"2021-10-12","baseline_start":"2021-02-16","baseline_end":"2021-11-17"},{"id":"5.4","name":"主体、二次结构拆改收尾（基于五项调整）","type":"里程碑","start":"2022-02-14","end":"2022-06-20","baseline_start":"2022-02-14","baseline_end":"2022-06-25"},{"id":"5.5","name":"幕墙施工","type":"一级","start":"2021-08-12","end":"2022-09-30","baseline_start":"2021-08-12","baseline_end":"2022-07-30"},{"id":"5.6","name":"机电安装及消防（五项调整影响）","type":"二级","start":"2021-12-01","end":"2022-09-30","baseline_start":"2021-12-01","baseline_end":"2022-11-08"},{"id":"5.7","name":"精装修施工 （家具安装）","type":"里程碑","start":"2022-06-12","end":"2023-01-31","baseline_start":"2022-06-12","baseline_end":"2023-03-27"},{"id":"5.8","name":"市政配套工程","type":"二级","start":"2022-04-21","end":"2022-11-30","baseline_start":"2022-04-21","baseline_end":"2023-03-27"},{"id":"5.10","name":"室外园林景观工程","type":"里程碑","start":"2022-05-01","end":"2022-12-30","baseline_start":"2023-02-19","baseline_end":"2023-07-04"},{"id":"6.0","name":"项目验收及移交","type":"","start":"2023-02-01","end":"2023-05-31","baseline_start":"2023-03-25","baseline_end":"2023-06-01"},{"id":"6.1","name":"规划验收","type":"一级","start":"2023-02-01","end":"2023-04-30","baseline_start":"2023-03-28","baseline_end":"2023-05-03"},{"id":"6.2","name":"人防验收","type":"一级","start":"2023-02-01","end":"2023-04-30","baseline_start":"2023-03-28","baseline_end":"2023-05-03"},{"id":"6.3","name":"其他专项验收（防雷、节能、环保、档案、永水、永电、燃气、市政等）","type":"二级","start":"2023-02-01","end":"2023-04-30","baseline_start":"2023-03-28","baseline_end":"2023-05-03"},{"id":"6.4","name":"消防验收","type":"一级","start":"2023-02-01","end":"2023-04-30","baseline_start":"2023-03-28","baseline_end":"2023-05-03"},{"id":"6.5","name":"五方验收","type":"一级","start":"2023-02-01","end":"2023-04-30","baseline_start":"2023-03-25","baseline_end":"2023-03-28"},{"id":"6.6","name":"竣工备案","type":"里程碑","start":"2023-05-01","end":"2023-05-31","baseline_start":"2023-05-04","baseline_end":"2023-06-01"},{"id":"7.0","name":"字节验收及移交","type":"","start":"2023-03-28","end":"2023-06-04","baseline_start":"2023-03-28","baseline_end":"2023-07-30"},{"id":"7.1","name":"IT设备安装调试，空气18883检测及厨房设备调试","type":"一级","start":"2023-03-28","end":"2023-05-27","baseline_start":"2023-03-28","baseline_end":"2023-05-27"},{"id":"7.2","name":"铁狮门移交及通风散味及字节验收移交","type":"一级","start":"2023-04-30","end":"2023-06-04","baseline_start":"2023-06-03","baseline_end":"2023-07-22"},{"id":"7.3","name":"搬家交付","type":"里程碑","start":"2023-06-04","end":"2023-06-04","baseline_start":"2023-07-22","baseline_end":"2023-07-30"}]};
    datasrc = datasrc.dataset;
    var end = [];
    if (type == 1)
    {
      for (var i = 0; i < datasrc.length; i++)
      {
        if (datasrc[i].type == "") end.push(datasrc[i]);
      }
    }else if ( type == 2){

      for (var i = 0; i < datasrc.length; i++)
      {
        if (datasrc[i].type == "里程碑") end.push(datasrc[i]);
      }
    }else if ( type == 3 )
    {
      return {"defaultZoomBeginDate":"2022-01-01","title":"","dataset":datasrc};
    }

    return {"defaultZoomBeginDate":"2022-01-01","title":"","dataset":end};
  }

  render(){
    let { isLoading,type }= this.state;
    return (
      <PageWrapper activeNav={"1-dashboard"}>
      <div className="DashboardPage pageWithPadding">

        <Row gutter={10} justify={"space-around"} style={{marginBottom:"1em"}}>

          <Col xs="12" sm="12" md="12" lg="6">
            <div className={"chartCard"}>
              <div className="chartCardHead">
                  <img src={require("../res/0818/1.png")}/>
                  成本RFI
              </div>
              <div className="chartCardBody">
                <ChartRfi/>
              </div>
            </div>

          </Col>
          <Col xs="12" sm="12" md="12" lg="6">
            <div className={"chartCard"}>
              <div className="chartCardHead">
                <img src={require("../res/0818/2.png")}/>
                安全/人力</div>
              <div className="chartCardBody" onClick={()=>{
                Facade.customHistory.push(`/dashboard-chart`);
              }}>
                <ChartAqrl/>
              </div>
            </div>
          </Col>
          <Col xs="12" sm="12" md="12" lg="6">
            <div className={"chartCard"}>
              <div className="chartCardHead">
                <img src={require("../res/0818/3.png")}/>
                质量NCR</div>
              <div className="chartCardBody">
                <ChartNcr/>
              </div>
            </div>

          </Col>
          <Col xs="12" sm="12" md="12" lg="6">
            <div className={"chartCard"}>
              <div className="chartCardHead">
                <img src={require("../res/0818/4.png")}/>
                <div>
                  风险<span style={{fontSize:"12px"}}>(意外和/或环境)</span></div>
              </div>
              <div className="chartCardBody">
                <ChartRisk/>
              </div>
            </div>

          </Col>
        </Row>


        <div className="groupborder">
          <Row style={{background:"#fff",marginBottom:"10px"}}>
            <Tabs activeName={"0"} className="shortTabs" onTabClick={this.onTabClick.bind(this)}>
              <Tabs.Pane label="近期计划" name="0">
              </Tabs.Pane>
              <Tabs.Pane label="基线计划" name="3"/>
              <Tabs.Pane label="基线计划-阶段" name="1"/>
              <Tabs.Pane label="基线计划-里程碑" name="2"/>
            </Tabs>
          </Row>

          <Row className="graphcards" gutter={10}>
            <WeekGraphCard name={"设计"} icon={require("../res/0818/Frame 283.png")} iconname={"fa fa-server"} val={848} delay={-16} />
            <WeekGraphCard name={"采购"} icon={require("../res/0818/Frame 283-1.png")} iconname={"fa fa-truck"} val={848} delay={16} />
            <WeekGraphCard name={"报建报批"} icon={require("../res/0818/Frame 283-2.png")} iconname={"fa fa-ticket"} val={516} delay={0} />
            <WeekGraphCard name={"施工"} icon={require("../res/0818/Frame 283-3.png")} iconname={"fa fa-road"} val={516} delay={0} />
            <WeekGraphCard name={"项目验收"} icon={require("../res/0818/Frame 283-4.png")} iconname={"fa fa-users"} val={516} delay={0} />
            <WeekGraphCard name={"移交入住"} icon={require("../res/0818/Frame 283-5.png")} iconname={"fa fa-suitcase"} val={516} delay={16} />
          </Row>


          <Row className="schedulechart" >

            <div className="chartCardHead">
              <img src={require("../res/0810/d1.png")}/>
              计划图表
            </div>
          </Row>
          <Row className="schedulechart" >
            <Col span={24}>
              <div id="chart_schedule_container">
              </div>
            </Col>
          </Row>
        </div>



      </div>
      </PageWrapper>);
  }

  onChange(v)
  {
    let type = v;
    this.showScheduleChart(type);
  }
  onTabClick(tab){
    let type = tab.props.name;
    this.showScheduleChart(type);
  }


}



const mapStateToProps=(state)=>
{
  return {
  };
};
export default connect(
  mapStateToProps
)(DashboardPage)